import React, { useMemo } from "react";
import { clsx } from "clsx";
import { useTranslation } from "react-i18next";

interface AvatarsProps {
  count: number;
  imageUrls: string[];
}

export const Avatars = ({ count = 6, imageUrls }: Partial<AvatarsProps>) => {
  const { t } = useTranslation();
  const selectedAvatars = useMemo(() => {
    // If imageUrls provided, slice to requested count
    if (imageUrls) {
      return imageUrls.sort(() => Math.random() - 0.5).slice(0, count);
    }

    const randomNumbers = Array.from({ length: 70 }, (_, i) => i + 1)
      .sort(() => Math.random() - 0.5)
      .slice(0, count);

    return randomNumbers.map((num) => `https://i.pravatar.cc/40?img=${num}`);
  }, [count, imageUrls]);

  return (
    <div
      role="group"
      aria-label={t("congrats.ariaLabel.avatarContainer")}
      className="relative flex items-center justify-center"
    >
      {selectedAvatars.map((avatar, index) => (
        <div
          key={`avatar-${index}`}
          className={clsx(
            "relative -m-[6px] rounded-full border-2 border-white",
          )}
        >
          <img
            aria-label={`Avatar ${index + 1}`}
            src={avatar}
            alt={`Avatar ${index + 1}`}
            className="h-10 w-10 rounded-full object-cover"
          />
        </div>
      ))}
    </div>
  );
};
